import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";

import { getSelectedBadgeItemId } from "slices";

const VideoFrame = ({ videoId, focusedVideo, index }) => {
  const selectedId = useSelector(getSelectedBadgeItemId);

  let player;

  const youtubeInit = (video) => {
    player = new window.YT.Player(`yt-player-${index}`, {
      videoId: video.url.split("v=")[1],
      events: {
        onStateChange: onPlayerStateChange,
        onError: onPlayerError,
      },
    });

    console.info("YouTube player initialized", player);
  };

  const onPlayerStateChange = (e) => {
    const currentTime = e.target.playerInfo.currentTime;
    const duration = e.target.playerInfo.duration;
    const percentage = (currentTime / duration) * 100;

    const eventHash = createEventHash(e.target.videoTitle, currentTime, percentage);
    window.parent.postMessage(JSON.stringify(eventHash), "*");
  };

  const onPlayerError = (e) => {
    console.error("Error in player", e);
  };

  // const removePlayer = () => {
  //   if (window.YT && window.YT.Player && player instanceof window.YT.Player) {
  //     player.destroy();
  //   }
  // };

  const vimeoInit = (video) => {
    try {
      const vimeoPlayer = new window.Vimeo.Player(video.url);

      vimeoPlayer.on(["pause", "ended"], function (data) {
        const eventHash = createEventHash(video.name, data.seconds, data.percentage * 100);
        window.parent.postMessage(JSON.stringify(eventHash), "*");
      });

      console.info("Vimeo player initialized", vimeoPlayer);
    } catch (err) {
      console.error("Error in Vimeo initialization", err);
    }
  };

  const videoInit = (video) => {
    const eventHash = createEventHash(video.name);
    window.parent.postMessage(JSON.stringify(eventHash), "*");
  };

  function createEventHash(videoTitle, watchDuration, watchPercentage) {
    return {
      event_name: "h_watch",
      event_params: {
        h_page_type: "hayley",
        h_stream: "hyly",
        h_display_method: "iframe",
        h_video_title: videoTitle,
        h_watch_duration: watchDuration,
        h_watch_percentage: watchPercentage,
        h_video_type: selectedId === "videos" ? "recorded video" : "3d video",
        h_view_type: selectedId === "videos" ? "videos" : "360 tours",
      },
    };
  }

  useEffect(() => {
    const initializeVideo = () => {
      if (!focusedVideo) {
        return;
      }

      const { url } = focusedVideo;

      if (url.includes("youtube.com")) {
        youtubeInit(focusedVideo);
      } else if (url.includes("vimeo.com")) {
        vimeoInit(focusedVideo);
      } else {
        videoInit(focusedVideo);
      }
    };
    initializeVideo();

    // return () => {
    //   removePlayer();
    // };
  }, [focusedVideo]);

  const getVideoSrc = (url, videoId) => {
    if (url.includes("vimeo.com")) {
      return `https://player.vimeo.com/video/${videoId}`;
    } else if (url.includes("youtube.com")) {
      return `https://www.youtube.com/embed/${videoId}`;
    }

    return url;
  };

  return (
    <Box key={videoId} className="hayley-flex hayley-flex-col">
      <Box id={`yt-player-${index}`} className="hayley-flex hayley-h-[240px] hayley-w-full hayley-items-center hayley-justify-center">
        <iframe
          id={`yt-player-${index}`}
          src={getVideoSrc(focusedVideo.url, videoId)}
          title={focusedVideo.name}
          className="hayley-h-full hayley-w-full hayley-border-none"
          allowFullScreen
        />
      </Box>
      <p className="hayley-m-0 hayley-pb-4 hayley-pt-1 hayley-text-xs hayley-text-secondary">{focusedVideo?.name}</p>
    </Box>
  );
};

export default VideoFrame;
